import React from "react";
import { Paper, Typography, Grid } from "@material-ui/core";
import { LOCALE } from "../../properties/Locale";
import { useDispatch } from "react-redux";
import { changePageTitle } from "../../common/actions/CommonActions";
import ActiveVacancyComponent from "./ActiveVacancyComponent";
import { VacancyRepository } from "./VacancyRepository";

export default function OpenVacanciesComponent() {
  const dispatch = useDispatch();
  const [vacancies, setVacancies] = React.useState();

  React.useEffect(() => {
    VacancyRepository.findAllByType().then(
      (res) => {
        setVacancies(res.data);
      },
      (err) => {}
    );
    dispatch(changePageTitle(LOCALE.open_vacancies));
  }, [dispatch]);

  return (
    <div>
      <Grid container spacing={2}>
        {vacancies?.map((item, index) => (
          <Grid key={index} item xs={12} sm={6} md={4}>
            <ActiveVacancyComponent vacancy={item}></ActiveVacancyComponent>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
